import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  deliverySuppliers: [],
  filters: { name: null, supplier: null, active: null },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    /**
     * Fornecedores ativos, usados para associar um fornecedor a uma loja.
     */
    deliverySupplierOptions(state) {
      return state.deliverySuppliers
        .filter(supplier => supplier.active)
        .map(supplier => ({ value: supplier.id, label: supplier.name }))
    },
  },

  mutations: {
    ...storePagination.mutations,

    SET_DELIVERY_SUPPLIERS(state, deliverySuppliers) {
      state.deliverySuppliers = deliverySuppliers
    },

    SET_FILTERS(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const { filters, paging, deliverySuppliers } = getInitialState()
      state.filters = filters
      state.paging = paging
      state.deliverySuppliers = deliverySuppliers
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchDeliverySuppliers({ commit, state }) {
      const { data } = await axios.get('/api/sales/delivery-suppliers', {
        params: {
          name: state.filters.name,
          active: state.filters.active,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_DELIVERY_SUPPLIERS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
